<template>
  <div class="title-wrapper">
    <h1 class="page-title">{{ title }}</h1>
    <a v-if="educationalVideoUrl" :href="educationalVideoUrl" class="watch-link" target="_blank">
      <img src="@/assets/images/icons/icon-play.svg" />
      Eğitim Videosunu İzle
    </a>
  </div>
</template>


<script setup>
const props = defineProps({
  title: {
    type: String,
    required: false,
    default: '',
  },
  backLastViewUrl: {
    type: String,
    required: false,
    default: '',
  },
  educationalVideoUrl: {
    type: String,
    required: false,
    default: ''
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/utilities.scss";

.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .page-title {
    color: var(--Neutral---Background-N80, #242424);
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.2px;
  }

  .watch-link {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    border-radius: 6px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;
    color: $colorN80;
    border: 0.5px solid #B3BBCB;
    background: $colorN00;

    img {
      margin-right: 4px;
    }
  }
  
  .backLastView-btn {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: -0.05px;
    color: $colorM50;
    display: flex;
    align-items: center;
    gap: 4px;

    &::before {
      content: '';
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg fill='none' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m7.4714 4.1381c0.26035-0.26035 0.26035-0.68246 0-0.94281s-0.68246-0.26035-0.9428 0l-3.3333 3.3333c-0.06392 0.06391-0.11214 0.13758-0.14467 0.21621-0.0326 0.07861-0.05059 0.1648-0.05059 0.25519s0.01799 0.17658 0.05059 0.25519c0.03179 0.07684 0.07857 0.14895 0.14034 0.21184m0.00473 0.00477 3.3329 3.3329c0.26034 0.2604 0.68245 0.2604 0.9428 0 0.26035-0.2603 0.26035-0.6824 0-0.94277l-2.1953-2.1953h6.3906c0.5304 0 1.0391 0.21071 1.4142 0.58578 0.3751 0.37508 0.5858 0.88378 0.5858 1.4142v4.6666c0 0.3682 0.2984 0.6667 0.6666 0.6667s0.6667-0.2985 0.6667-0.6667v-4.6666c0-0.88406-0.3512-1.7319-0.9763-2.357s-1.473-0.97631-2.357-0.97631h-6.3906l2.1953-2.1953' clip-rule='evenodd' fill='%235D3EBC' fill-rule='evenodd'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat no-repeat;
      display: block;
      width: 18px;
      height: 18px;
    }
  }
}
</style>